import { RichText, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import Grid from '@mui/material/Grid';
import { ComponentProps } from '../../lib/component-props';
import ImageCtaCard from '../shared/ImageCtaCard/ImageCtaCard';
import { StImageCardContainer } from './ContentWithIconList.style';
import { ImageCtaCardProps } from '../../components/shared/ImageCtaCard/ImageCtaCard.type';
import { StCRGridContainer, STCRWrapper } from '../../components/shared/Container/Container.styles';
import { useDispatch } from 'react-redux';
import { updateLastVisitedComponentId } from '../../features/globalConfig';
import { useTheme } from '@mui/material/styles';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import UiHeading from '../shared/Heading';
import UiBox from '../shared/Box';
import { DEFAULT_PRIMARY_FONT_FAMILY } from 'theme/fontDefaults';

type IconListProps = {
  fields: ImageCtaCardProps;
};

type ContentWithIconListProps = ComponentProps & {
  fields: {
    heading: Field<string>;
    content: Field<string>;
    iconList: IconListProps[];
  };
};

const ContentWithIconList = (props: ContentWithIconListProps): JSX.Element => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { sitecoreContext } = useSitecoreContext();
  const siteSettings: any = sitecoreContext?.siteSettings;
  if (!props?.fields) return <></>;
  const onClickHandler = () => {
    dispatch(updateLastVisitedComponentId('content-with-icon-list'));
  };
  return (
    <div style={{ backgroundColor: '#F7F8FA', maxWidth: 'calc(100vw - 10px)' }}>
      <STCRWrapper id="content-with-icon-list" className="ui-content-with-icon-list">
        <StCRGridContainer>
          <>
            <UiBox
              styles={{
                marginBottom: '8px',
                lineHeight: '1.5rem',
              }}
            >
              <UiHeading
                data-testid="title"
                size="h2"
                align="center"
                styles={{ color: theme.palette.neutral8.main }}
              >
                {props?.fields?.heading}
              </UiHeading>
            </UiBox>
            <RichText
              data-testid="content"
              style={{
                color: theme.palette.neutral8.main,
                marginTop: '1rem',
                fontSize: '1.125rem',
                fontWeight: 500,
                fontFamily: `${
                  siteSettings?.fontFamily?.fields?.primaryFontFamilyType?.value ||
                  DEFAULT_PRIMARY_FONT_FAMILY
                }, sans-serif`,
              }}
              field={props?.fields?.content}
            />
          </>
          <StImageCardContainer>
            {props?.fields?.iconList &&
              props?.fields?.iconList.map((item, i) => (
                <Grid item key={i}>
                  <ImageCtaCard
                    icon={item?.fields?.icon}
                    link={item?.fields?.link}
                    buttonVariant={item?.fields?.buttonVariant}
                    onClick={onClickHandler}
                  />
                </Grid>
              ))}
          </StImageCardContainer>
        </StCRGridContainer>
      </STCRWrapper>
    </div>
  );
};

export default ContentWithIconList;
